export const BUTTON_LOCATION_BACKLOG = 'backlog';
export const BUTTON_LOCATION_KANBAN = 'kanban';
export const BUTTON_LOCATION_SCRUM = 'scrum';

export const BUTTON_LOCATION_BACKLOG_VISUAL_REFRESH = 'backlog-visual-refresh';
export const BUTTON_LOCATION_KANBAN_VISUAL_REFRESH = 'kanban-visual-refresh';
export const BUTTON_LOCATION_SCRUM_VISUAL_REFRESH = 'scrum-visual-refresh';
